var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entries)?_c('sales-summary',{attrs:{"entries":_vm.entries,"loading":_vm.loading}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }